import * as types from '@/store/types'
import Vue from 'vue'
export default {
    changeStatusLoaded: (context, payload) => {
        context.loaded = payload
    },
    cardAll: (context, payload) => {
        context.cards = payload
        context.cardsLoaded = true
    },
    cardUpdate: (context, payload) => {
        const index = context.cards.findIndex(item => item.id === payload.id)
        context.cards[index] = payload
    },
    cardCreate(context, payload) {
        context.cards.push(payload)
    },
    cardDelete(context, payload) {
        const index = context.cards.findIndex(item => item.id === payload.id)
        context.cards.splice(index, 1)
    },
    changeBotIdModelDefault: (context, botId) => {
        context.cardModelDef.bot_id = botId
        context.cardListModelDef.bot_id = botId
        context.cardCommentModelDef.bot_id = botId
    },
    cardListAll: (context, payload) => {
        let unsortedCardsListId = payload.find(cardList => cardList.status === 3)
        if (unsortedCardsListId)
            context.unsortedCardsListId = unsortedCardsListId.id
        context.cardLists = payload
        context.cardListsLoaded = true
    },
    cardListUpdate(context, payload) {
        const index = context.cardLists.findIndex(item => item.id === payload.id)
        context.cardLists[index] = payload
    },
    cardListCreate(context, payload) {
        context.cardLists.push(payload)
    },
    cardListDelete(context, payload) {
        const index = context.cardLists.findIndex(item => item.id === payload.id)
        context.cardLists.splice(index, 1)
    },
    allLoadedChangeValue(context, value) {
        context.cardsLoaded = false
        context.cardListsLoaded = false
    },
    loadCardSortedInList(context, cardSortedInList) {
        context.cardSortedInList = Object.assign({}, cardSortedInList)
    },
    addCardToCardList (context, payload) {
        // context.cardSortedInList[payload.cardListId].splice(i, 1)
        context.cardSortedInList[payload.cardListId].push(payload.card)
    },
    deleteCardInCardList (context, payload) {
        context.cardSortedInList[payload.cardListId].splice(payload.index, 1)
    },
    updateCardInCardList (context, payload) {
        this.cardSortedInList[payload.cardListId][payload.index] = Object.assign({}, payload.cardModel)
    },
    addNewCardsList (context, payload) {
        Vue.set(this.cardSortedInList, payload.id, [])
    },
    cardCommentAll: (context, payload) => {
        context.cardComments = payload
        context.cardCommentsLoaded = true
    },
    cardCommentUpdate: (context, payload) => {
        const index = context.cardComments.findIndex(item => item.id === payload.id)
        context.cardComments[index].description = payload.description
    },
    cardCommentCreate(context, payload) {
        context.cardComments.push(payload)
    },
    cardCommentDelete(context, payload) {
        const index = context.cardComments.findIndex(item => item.id === payload.id)
        context.cardComments.splice(index, 1)
    },
    cardCategoryAll: (context, payload) => {
        context.cardCategories = payload
        context.cardCategoriesLoaded = true
    },
    cardCategoryUpdate(context, payload) {
        const index = context.cardCategories.findIndex(item => item.id === payload.id)
        context.cardCategories[index] = payload
    },
    cardCategoryCreate(context, payload) {
        context.cardCategories.push(payload)
    },
    cardCategoryDelete(context, payload) {
        const index = context.cardCategories.findIndex(item => item.id === payload.id)
        context.cardCategories.splice(index, 1)
    },
    cardCategoryShowChange(context, value) {
        context.cardCategoryFormShow = value
    },
    lastLoadedCategoryIdUpdate(context, categoryId) {
        context.lastLoadedCategoryId = categoryId
    },
    addCard(context, cardModel) {
        context.cards.push(cardModel)
    },
    tagAll(context, payload) {
        context.tags = payload
    },
    tagUpdate: (context, payload) => {
        const index = context.tags.findIndex(item => item.id === payload.id)
        context.tags[index] = payload
    },
    tagCreate(context, payload) {
        context.tags.push(payload)
    },
    tagDelete(context, payload) {
        const index = context.tags.findIndex(item => item.id === payload.id)
        context.tags.splice(index, 1)
    },
    cardTagsInCard(context, payload) {
        context.cardTagsInCard = payload
    },
    deliveriesAll(context, payload) {
        context.deliveries = payload
    },
    deliveryUpdate(context, payload) {
        const index = context.deliveries.findIndex(item => item.id === payload.id)
        Vue.set(context.deliveries, index, payload)
    },
    deliveryCreate(context, payload) {
        context.deliveries.push(payload)
    },
    deliveryDelete(context, payload) {
        const index = context.deliveries.findIndex(item => item.id === payload.id)
        context.deliveries.splice(index, 1)
    },
    promoAll(context, payload) {
        context.promos = payload
    },
    promoUpdate(context, payload) {
        const index = context.promos.findIndex(item => item.id === payload.id)
        Vue.set(context.promos, index, payload)
    },
    promoCreate(context, payload) {
        context.promos.push(payload)
    },
    promoDelete(context, payload) {
        const index = context.promos.findIndex(item => item.id === payload.id)
        context.promos.splice(index, 1)
    },
    catalogStockEdit(context, payload) {
        const index = context.promos.findIndex(item => item.id === payload.id)
        context.promos.splice(index, 1)
    }
}
